export default "__VITE_ASSET__D4ajNMJg__"